import React from 'react';

import withAuthorization from '../../enhancers/withAuthorization';

const App = props => <div className="App">{props.children}</div>;

export default withAuthorization(App);
